import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container, IconButton, Paper, Stack, Tooltip, Typography } from "@mui/material";
import Service from "../../util/Service";
import HtmlContent from "../util/HtmlContent";
import { Edit, Home } from "@mui/icons-material";
import { useProfile } from "../common/useProfile";

export default function ProjetoPageView() {
    const params = useParams();
    const location = useLocation();
    const prof = useProfile();
    const navigate = useNavigate();
    const { showGoToHome } = location.state || false; // Use destructuring with a default empty object for safety
    const [projeto, setProjeto] = React.useState();

    console.log( showGoToHome )
    React.useEffect(() => {
        buscaProjeto();
    }, [])
    function buscaProjeto() {
        const id = params.id;
        Service.GET("/api/projeto/porId/" + id).then(r => {
            setProjeto(r);
        });
    }

    return (
        <Container>
            {showGoToHome && 
            <div className="vr-float-dir">
                <Tooltip title="Ir para pagina home do portal">
                    <IconButton aria-label="edit" color="primary"
                        //sx={{ float: 'left', ml: -5, mt: -1 }}
                        onClick={() => navigate("/home")}
                    //onClick={()=> console.log('>>>>>>')}
                    >
                        <Home />
                    </IconButton>
                </Tooltip>
            </div>}
            {prof.temAcesso("ProjectAdm") &&
                <div className="vr-float-dir">
                    <Tooltip title="Ir para edição do projeto">
                        <IconButton aria-label="edit" color="primary"
                            //sx={{ float: 'left', ml: -5, mt: -1 }}
                            onClick={() => navigate('/project/pagina/'+params.id, { state: {} })}
                        //onClick={()=> console.log('>>>>>>')}
                        >
                            <Edit />
                        </IconButton>
                    </Tooltip>
                </div>}
            <Paper>
                <Stack sx={{ p: 0 }}>
                    {projeto && !projeto.pagina && 
                        <Typography variant="h6" component="h2" style={{ textAlign: "center" }}>
                            {projeto.descricao}
                        </Typography>}
                    <HtmlContent htmlString={projeto ? projeto.pagina : ''} />
                </Stack>
            </Paper>
        </Container>
    )
}